import { Button, Classes, Dialog, Drawer, Collapse, Intent } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import { DivColumn, DivLine } from '../../styledComponents/StyledComponents';
//import 'devextreme/localization/globalize';
import { locale, loadMessages } from 'devextreme/localization';
import frMessages from 'devextreme/localization/messages/fr.json';


// import { Instance } from 'mobx-state-tree';
// import { PharmacyDetails } from '../../../store/models';
import {
  DataGrid,
  Column,
  SearchPanel,
  Button as DGButton,
  DataGridTypes,
  Export,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  Toolbar,
  Item,
  ColumnChooser,
  FilterPanel,
  Sorting,
  MasterDetail,
} from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { WithTranslateProps } from '../../WithTranslate';
import { TLCode } from '../../../../common/enums';
import { Instance } from 'mobx-state-tree';
import { PharmacyDetails } from '../../../../store/models';
import moment from 'moment';


interface CandidatesDialogProps extends WithTranslateProps {
  isOpen: boolean;
  getAvailablePharmacyList?: (date, apbNumber, showAlsoCurrentPharmacy) => Promise<any[]>;
  onClose?: (canBeReopen: boolean) => void;
  onCancel?: () => void;
  onContinue?: () => void;
  onSelectPharmacy?: (pharmacy: Instance<typeof PharmacyDetails> | undefined) => Promise<boolean>;
  message?: string;
  messageContent?: JSX.Element;
  confirmText?: string;
  cancelText?: string;
  date: string;
  pharmacy: any; //Instance<typeof PharmacyDetails>;
  availablePharmacyList?: any[],
  availablePharmacies?: any[],
}

const onExporting = (e) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Main sheet');
  exportDataGrid({
    component: e.component,
    worksheet: worksheet,
    customizeCell: function (options) {
      options.excelCell.font = { name: 'Arial', size: 12 };
      options.excelCell.alignment = { horizontal: 'left' };
    },
  }).then(function () {
    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
    });
  });
};

export const CandidatesDialog = ({
  isOpen,
  onClose,
  onCancel,
  onContinue,
  onSelectPharmacy,
  translate,
  message = '',
  messageContent,
  confirmText,
  cancelText,
  date,
  pharmacy,
  getAvailablePharmacyList,
  availablePharmacyList,
  availablePharmacies,
}: CandidatesDialogProps) => {
  // const [isDialogOpen, setIsDialogOpen] = useState(isOpen);
  const [getAvailablePharmacies, setAvailablePharmacies] = useState<any[]>([]); //useState([]);
  const [pharmacyIsLoading, setPharmacyIsLoading] = useState<boolean>(false);


  // useEffect(() => {
  //   if (isOpen && getAvailablePharmacyList !== undefined) {
  //     var res = getAvailablePharmacyList(date, pharmacy.apbNumber);
  //     setAvailablePharmacies( res );
  //   } else {
  //     //closeDialog();
  //   }
  // }, [isOpen]);

  useEffect(() => {
    let isMounted = true;

    async function loadAvailablePharmacyList() {
      try {
        if (getAvailablePharmacyList !== undefined) {
          const res = await getAvailablePharmacyList(date, pharmacy.apbNumber, true);
          if (isMounted) {
            setAvailablePharmacies(res);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (isOpen && availablePharmacyList !== undefined) {
      loadAvailablePharmacyList();
    }

    return () => {
      isMounted = false;
    };
  }, [isOpen]);

  useEffect(() => {
    console.log('pharmacyIsLoading: ' + pharmacyIsLoading);
  }, [pharmacyIsLoading]);

  // const closeDialog = () => {
  //   setIsDialogOpen(false);
  // };

  // const openDialog = () => {
  //   setIsDialogOpen(true);
  // };

  // const handleContinue = () => {
  //   //onContinue();
  //   closeDialog();
  // };

  // const handleCancelAction = () => {
  //   if (onCancel !== undefined) onCancel();
  //   closeDialog();
  // };

  // useEffect(() => {
  //   if (isOpen) {
  //     openDialog();
  //   } else {
  //     closeDialog();
  //   }
  // }, [isOpen]);

  const buildGridData = () => {
    //if (getAvailablePharmacies !== undefined && getAvailablePharmacies.length > 0) {
    if (availablePharmacyList !== undefined && availablePharmacyList.length > 0) {
      return availablePharmacyList.map((elem) => ({
        apbNumber: elem["apbNumber"],
        name: elem["name"],
        address: elem["address"],
        zipCode: elem["zipCode"],
        city: elem["city"],
        distance: elem["distance"],
        dutyCnt: elem["dutyCount"],
        JdutyCnt: elem["dutyCount"] - elem["dayNightDutyCount"],
        JNdutyCnt: elem["dayNightDutyCount"],
        prevDutyCnt: elem["prevDutyCount"],
        semSaturdays: elem["saturdays"],
        yearSaturdays: elem["yearSaturdays"],
        semSundays: elem["sundays"],
        yearSundays: elem["yearSundays"],
        semBkhCnt: elem["bankHolidays"],
        yearBkhCnt: elem["yearBankHolidays"],
        anchorName: elem["anchorName"],
        transferrableDuties: elem["transferrableDuties"],
      }));
    } else return null;
  };

  const formattedDate = moment(date).format("dddd DD-MM-YYYY");
  //const title = `Pharmacies disponibles ${formattedDate} pour permutation avec ${pharmacy ? pharmacy.apbNumber+' '+pharmacy.name: ''}`;
  const title = translate(TLCode.CANDIDATES_DIALOG_TITLE, { formattedDate, pharmacyApbNumber: pharmacy ? pharmacy.apbNumber+' '+pharmacy.name : '' });
  const handleClose = (withResetDatas: boolean) => {
    if (withResetDatas){
      setAvailablePharmacies([]);
    }

    if (onClose) {
      onClose(!withResetDatas);
    }
  };

  const SelectPharmacy = (data) => {
    setPharmacyIsLoading(true);
    if (onSelectPharmacy) {
      console.log(data);
      onSelectPharmacy(data).then((result) => {
        console.log('Résultat du callback onSelectPharmacy:', result);
        setPharmacyIsLoading(false);
      });
    }

    if (onClose) {
      onClose(true);
    }
  }

  loadMessages(frMessages);
  locale('fr');
  return (

    <>
      <Dialog isOpen={isOpen} canOutsideClickClose={false} style={{ width: '1410px', height: '100%', zIndex: 1001 }} >
        <div className={Classes.DIALOG_HEADER}>
          <h1>{title}</h1>
        </div>
        <div className={Classes.DIALOG_BODY}>
          <br />
          {messageContent !== undefined ? messageContent : message}
          <DivLine style={{ display: 'flex', justifyContent: 'center' }}>
            <DivColumn>
              <DataGrid
                dataSource={buildGridData()}
                showBorders={true}
                allowColumnReordering={true}
                rowAlternationEnabled={false}
                width="1310px"
                allowColumnResizing={true}
                columnResizingMode={'widget'}
                onExporting={onExporting}
              >
                <Sorting mode="multiple" />
                <FilterRow visible={true} applyFilter={'auto'} />
                <SearchPanel visible={true} highlightCaseSensitive={true} width={400} />
                <HeaderFilter visible={true} />
                <FilterPanel visible={true} />
                <Export enabled={true} />
                <Paging defaultPageSize={20} />
                <Pager
                  visible={true}
                  allowedPageSizes={[20, 50, 100, 'all']}
                  showPageSizeSelector={true}
                  showInfo={true}
                  showNavigationButtons={true}
                />
                <ColumnChooser enabled={true} />
                <Column
                  dataType="string"
                  dataField="anchorName"
                  caption={'ancrage'}
                  width={65}
                /><Column
                  dataType="string"
                  dataField="apbNumber"
                  caption={'APB'}
                  width={65}
                />
                <Column
                  dataType="string"
                  dataField="name"
                  caption={'Nom'}
                  width={180}
                />
                <Column
                  dataType="string"
                  dataField="address"
                  caption={'Adresse'}
                  width={150}
                />
                <Column
                  dataType="string"
                  dataField="zipCode"
                  caption={'CP'}
                  width={60}
                />
                <Column
                  dataType="string"
                  dataField="city"
                  caption={'Localité'}
                  width={100}
                />
                <Column
                  dataType="number"
                  dataField="distance"
                  caption={'m'}
                  width={65}
                  defaultSortOrder="asc"
                  sortIndex={1}
                />
                <Column
                  dataType="number"
                  dataField="dutyCnt"
                  caption={'Gardes'}
                  width={70}
                />
                <Column
                  dataType="number"
                  dataField="JdutyCnt"
                  caption={'J'}
                  width={60}
                />
                <Column
                  dataType="number"
                  dataField="JNdutyCnt"
                  caption={'J+N'}
                  width={60}
                />
                <Column
                  dataType="number"
                  dataField="semSaturdays"
                  caption={'SA'}
                  width={60}
                />
                <Column
                  dataType="number"
                  dataField="yearSaturdays"
                  caption={'SA/an'}
                  width={70}
                />
                <Column
                  dataType="number"
                  dataField="semSundays"
                  caption={'DI'}
                  width={60}
                />
                <Column
                  dataType="number"
                  dataField="yearSundays"
                  caption={'DI/an'}
                  width={70}
                />
                <Column
                  dataType="number"
                  dataField="semBkhCnt"
                  caption={'fériés'}
                  width={60}
                />
                <Column
                  dataType="number"
                  dataField="yearBkhCnt"
                  caption={'fériés/an'}
                  width={70}
                />
                {/* <Column
                  dataType="string"
                  dataField="transferrableDuties"
                  caption={'gardes'}
                  width={170}
                /> */}
                <MasterDetail enabled={true} component={({data}) => (
                    <div style={{ padding: 1, background: "#fafafa" }}>
                    <h4 style={{ marginBottom: 1 }}>
                      Gardes {data.data.apbNumber}&nbsp;&nbsp;{data.data.name}
                    </h4>

                    {/* Cas 1 : aucun produit */}
                    {(!data.data.transferrableDuties || data.data.transferrableDuties.length === 0) && (
                      <div style={{ fontStyle: "italic", color: "#999" }}>
                        Aucune garde
                      </div>
                    )}

                    {/* Cas 2 : sous-grille avec liste de nombres */}
                    {data.data.transferrableDuties!.length > 0 && (
                      <DataGrid
                        dataSource={data.data.transferrableDuties.map((num, index) => ({
                          id: index + 1,
                          code: num,
                        }))}
                        keyExpr="id"
                        showBorders={true}
                        columnAutoWidth={true}
                        rowAlternationEnabled={true}
                        height="auto"
                      >
                        <Column dataField="id" caption="#" width={50} />
                        <Column dataField="code" caption="Date" width={150}/>
                      </DataGrid>
                    )}
                  </div>
                )} />
                <Column
                  caption="Actions"
                  type="buttons"
                  width={60}>
                  <DGButton
                    hint={translate(TLCode.USER_Goto_Pharmacy)}
                    icon={'home'}
                    onClick={(e) => {
                      if (e.row) {
                        console.log('Selected pharmacy:', e.row.data);
                        SelectPharmacy(e.row.data);
                      }
                    }}
                  />
                </Column>
              </DataGrid>
            </DivColumn>
          </DivLine>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={() => handleClose(false)} intent={Intent.PRIMARY} disabled={false}>
              {translate(TLCode.GENERAL_Close)}
            </Button>
            <Button onClick={() => handleClose(true)} intent={Intent.DANGER} disabled={false} style={{ marginLeft: '5px' }}>
              {translate(TLCode.GENERAL_Cancel)}
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};
